import React from "react";
import PropTypes from "prop-types";
import { useInView } from "react-intersection-observer";

// components
import LogoCarouselComponent from "../../Global/LogoCarousel/LogoCarousel";

// images
import iciciLogo from "../../../images/forInsurer/icici.png";
import bajajLogo from "../../../images/forInsurer/bajaj.png";
import rahejaLogo from "../../../images/forInsurer/raheja.png";
import starLogo from "../../../images/forInsurer/star.png";
import galaxyLogo from "../../../images/forInsurer/galaxy.png";

// styles
import * as styles from "./HealthPartner.module.css";

const propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
};

const defaultProps = {
  title: "Global Health Insurance Partnerships in India",
  subtitle: "Trusted by Insurers Across India and the World",
  description:
    "Twin Health partners with leading global insurance providers to integrate metabolic care and precision health into insurance plans, improving outcomes and reducing claim costs.",
};

const HealthPartner = ({ title, subtitle, description }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  // Insurance partner logos
  const insuranceLogos = [
    { src: iciciLogo, alt: "ICICI Lombard" },
    { src: bajajLogo, alt: "Bajaj Allianz" },
    { src: rahejaLogo, alt: "Raheja QBE" },
    { src: starLogo, alt: "Star Health Insurance" },
    { src: galaxyLogo, alt: "Galaxy Health Insurance" },
  ];

  return (
    <section className={styles.healthPartnerWrapper}>
      <div
        className={`container scroll_animate ${inView && "inview"}`}
        ref={ref}
      >
        {/* Header Section */}
        <div className={styles.headerSection}>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.subtitle}>{subtitle}</p>
          <p className={styles.description}>{description}</p>
        </div>
      </div>

      {/* Logo Carousel Section */}
      <div className={styles.logoSection}>
        <LogoCarouselComponent
          title=""
          backgroundColor="transparent"
          logos={insuranceLogos}
          speed={10}
        />
      </div>
    </section>
  );
};

HealthPartner.propTypes = propTypes;
HealthPartner.defaultProps = defaultProps;

export default HealthPartner;
